<template>
  <div
  v-if="product"
  class="popup-dv-mask"
  @click.self="$emit('close')"
>
    <div class="popup-dv">

      <!-- HEADER -->
      <div class="popup-dv-header">
        <span class="m-auto" style="font-size: 18px; font-weight: 700;">{{ product.name }}</span>
        <!-- <button @click="$emit('close')">✕</button> -->
      </div>

      <!-- TABS -->
      <div class="tab-bar">
        <div v-for="t in tabs" :key="t" :class="['tab', { active: activeTab === t }]" @click="activeTab = t">
          {{ t }}
        </div>
      </div>

      <!-- CONTENT -->
      <div class="tab-content">

        <!-- TAB SẢN PHẨM -->
        <div v-if="activeTab === 'Sản phẩm'">

          <!-- ẢNH -->
          <div class="container-fluid">
            <div class="row">
              <div class="col-12 col-md-7">
                <div class="main-img m-auto">
                  <img :src="currentImage" />
                </div>

                <div class="thumb-list">
                  <div v-for="(img, i) in images" :key="i" class="thumb" :class="{ active: img === currentImage }"
                    @click="currentImage = img">
                    <img :src="img" />
                  </div>
                </div>

              </div>
              <div class="col-12 col-md-5">


                <!-- CHIẾT KHẤU -->
                <div class="discount-box mt-4">
                  <div v-for="s in saleList" :key="s" class="discount-row" :class="{ active: autoSale === s }">
                    <div class="discount-left">Chiết khấu {{ s }}%</div>
                    <div class="discount-right"> {{ saleRules[Number(s)]?.text }}
                    </div>
                  </div>
                </div>

                <!-- SỐ LƯỢNG -->
                <div class="qty-box">
                  <div class="qty-label">Số lượng</div>
                  <div class="qty-control justify-content-between">
                    <button @click="decreaseQty">−</button>
                    <input type="number" v-model.number="quantity" @input="onQtyChange" />
                    <button @click="increaseQty">+</button>
                  </div>
                  <div v-if="autoSale" class="sale-badge mt-3" style="color: red;">
                    🔖 Đã áp dụng - {{ autoSale }}%
                  </div>
                  <!-- <div v-if="autoSale" class="save">
                🎉 Tiết kiệm
                {{ formatPrice(baseSellPrice * quantity - buyPrice) }}₫ 
              </div> -->
                </div>
                <div style="font-size: 13px; " class="mt-3">
                  <i> (*)
                    Phương thức thuê thiết bị chỉ áp dụng tại xã/phường thí điểm của Vimass.
                  </i>
                </div>

                <div v-if="suggestedProducts.length" class="suggested-box mt-4">
                  <div class="suggested-title">
                    🔥 Sản phẩm gợi ý
                  </div>

                  <div class="suggested-list">
                    <div v-for="sp in suggestedProducts" :key="sp.id" class="suggested-item" @click="goDetail(sp.id)">
                      <img :src="sp.image.split(';')[0]" class="suggested-img" />

                      <div class="suggested-info">
                        <div class="suggested-name">
                          {{ sp.name }}
                        </div>
                        <div class="suggested-price">
                          {{ formatPrice(sp.price) }}₫
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <!-- CHIẾT KHẤU + SỐ LƯỢNG -->


          <!-- BADGE SALE -->


          <!-- GIÁ TÓM TẮT -->
          <div class="price-summary d-none">
            <div v-if="autoSale" class="price-row">
              <span>Giá gốc</span>
              <span class="old">
                {{ formatPrice(baseSellPrice * quantity) }}₫
              </span>
            </div>

            <div class="price-row highlight">
              <span>Giá sau ưu đãi</span>
              <span class="final">
                {{ formatPrice(buyPrice) }}₫
              </span>
            </div>


          </div>

        </div>

        <!-- TAB THÔNG TIN -->
        <div v-if="activeTab === 'Thông tin'" class="p-4">
          <div class="desc" v-html="formatDesc(product.description)"></div>
          <div class="desc mt-3" v-html="formatDesc(product.huongdan)"></div>
          <div style="font-size: 13px; font-weight: 600;" class="mt-3">
            - Phương thức thuê thiết bị chỉ áp dụng tại xã/phường thí điểm của Vimass.<br>
            - Tiền đặt cọc thuê thiết bị bằng 1 tháng tiền
            thuê; không
            được phép cho thuê lại; gia hạn hoặc trả thiết bị cần báo trước 1 tháng; thiết bị trả lại phải hoạt động
            bình thường;
            hư hỏng, mất mát phải bồi thường theo giá trị thực tế. <br>
            - Hết thời hạn thuê, khách hàng có thể mua thiết bị theo giá trị còn lại được Vimass công bố từng thời kỳ;
            tiền cọc
            được hoàn trả hoặc khấu trừ vào giá mua thiết bị.
          </div>
        </div>

      </div>

      <!-- FOOTER -->
      <div class="popup-dv-footer">
        <!-- THUÊ -->
        <button class="btn rent action-btn" @click="addToCart('rent', {
          product: product,
          quantity: quantity,
          unitPrice: Math.round(rentPrice / quantity),
          total: rentPrice,
          sale: autoSale
        })">
          <div class="btn-title">
            <span class="action-text">Thuê ngay 📦</span>
            <span class="action-price">{{ formatPrice(rentPrice) }}₫</span>
          </div>
        </button>

        <!-- MUA -->
        <button class="btn buy action-btn" @click="addToCart('buy', {
          product: product,
          quantity: quantity,
          unitPrice: Math.round(buyPrice / quantity),
          total: buyPrice,
          sale: autoSale
        })">
          <div class="btn-title">
            <span class="action-text">Mua ngay 🛒</span>
            <span class="action-price">{{ formatPrice(buyPrice) }}₫</span>
          </div>
        </button>
      </div>

    </div>
  </div>
  <div v-if="toast.show" class="toast">
  {{ toast.message }}
</div>
</template>

<script>
export default {
  props: { product: Object },

  data() {
    return {
      activeTab: "Sản phẩm",
      tabs: ["Sản phẩm", "Thông tin"],
      currentImage: "",
      quantity: 1,
      products: [],
        toast: {
      show: false,
      message: ''
    }
    };
  },

  computed: {
    cartCount() {
      const cart = JSON.parse(localStorage.getItem("cart") || "[]")
      return cart.reduce((sum, i) => sum + i.quantity, 0)
    },
    images() {
      return this.product?.image?.split(";").filter(Boolean) || [];
    },

    saleList() {
      return this.product?.sale?.split(";").map(Number) || [];
    },

    saleRules() {
      return {
        5: { min: 5, max: 20, text: "5 – 20 sản phẩm" },
        10: { min: 21, max: 50, text: "21 – 50 sản phẩm" },
        15: { min: 51, max: Infinity, text: "Trên 50 sản phẩm" }
      };
    },

    autoSale() {
      let s = null;
      this.saleList.forEach(p => {
        const r = this.saleRules[p];
        if (r && this.quantity >= r.min && this.quantity <= r.max) s = p;
      });
      return s;
    },
    suggestedProducts() {
      if (!this.product?.idsanphamgoiy) return []

      const ids = this.product.idsanphamgoiy
        .split(';')
        .map(id => Number(id))
        .filter(Boolean)

      return this.products.filter(p => ids.includes(p.id))
    },
    baseSellPrice() {
      return Number(this.product?.price) || 0;
    },

    baseRentPrice() {
      return Number(this.product?.giaThue) || 0;
    },

    buyPrice() {
      const price = this.autoSale
        ? this.baseSellPrice * (100 - this.autoSale) / 100
        : this.baseSellPrice;
      return Math.round(price * this.quantity);
    },

    rentPrice() {
      const price = this.autoSale
        ? this.product?.giaThueSale?.[this.autoSale] || this.baseRentPrice
        : this.baseRentPrice;
      return Math.round(price * this.quantity);
    }
  },

  watch: {
    images: {
      immediate: true,
      handler(v) {
        if (v.length) this.currentImage = v[0];
      }
    }
  },

  methods: {
    formatDesc(text) {
      if (!text) return ''
      return text
        .replace(/\n\n/g, '<br><br>')   // xuống dòng đoạn
        .replace(/\n/g, '<br>')        // xuống dòng thường
        .replace(/- /g, '• ')          // gạch ngang → bullet
    },
    increaseQty() { this.quantity++; },
    decreaseQty() { if (this.quantity > 1) this.quantity--; },
    onQtyChange() { if (this.quantity < 1) this.quantity = 1; },
    formatPrice(v) { return Number(v).toLocaleString("vi-VN"); },
    onBuy() {
      this.$emit("buy", {
        product: this.product,
        quantity: this.quantity,
        unitPrice: Math.round(this.buyPrice / this.quantity),
        total: this.buyPrice,
        sale: this.autoSale
      })
    },

    onRent() {
      this.$emit("rent", {
        product: this.product,
        quantity: this.quantity,
        unitPrice: Math.round(this.rentPrice / this.quantity),
        total: this.rentPrice,
        sale: this.autoSale
      })
    },
    addToCart(type, payload) {
      if (!payload || !payload.product) {
        console.error("addToCart thiếu payload", payload)
        return
      }

      const cart = JSON.parse(localStorage.getItem("cart") || "[]")

      const item = {
        id: payload.product.id,
        name: payload.product.name,
        image: payload.product.image?.split(";")[0],
        type, // buy | rent
        quantity: payload.quantity,
        sale: payload.sale,
        unitPrice: payload.unitPrice,
        total: payload.total
      }

      const existed = cart.find(
        i =>
          i.id === item.id &&
          i.type === item.type &&
          i.sale === item.sale
      )

      if (existed) {
        existed.quantity += item.quantity
        existed.total += item.total
      } else {
        cart.push(item)
      }

      localStorage.setItem("cart", JSON.stringify(cart))

      // optional
      this.$emit("added-to-cart", cart)

        // this.$emit("close")
        // alert("🛒 Đã thêm vào giỏ hàng !")
        window.location.reload();
    },

    // removeItem(index) {
    //   this.cartItems.splice(index, 1)
    //   localStorage.setItem("cart", JSON.stringify(this.cartItems))
    // },
   
  }
};
</script>

<style scoped>
.suggested-box {
  border-top: 1px solid #eee;
  padding-top: 12px;
}

.suggested-title {
  font-weight: 600;
  margin-bottom: 8px;
}

.suggested-list {
  display: flex;
  gap: 10px;
  overflow-x: auto;
}

.suggested-item {
  min-width: 120px;
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 6px;
  cursor: pointer;
  background: #fff;
}

.suggested-item:hover {
  border-color: #ff7a00;
}

.suggested-img {
  width: 100%;
  height: 80px;
  object-fit: contain;
}

.suggested-name {
  font-size: 13px;
  margin-top: 4px;
}

.suggested-price {
  font-size: 13px;
  font-weight: 600;
  color: #e53935;
}

/* ===== SALE + QTY ROW ===== */
.sale-qty-row {
  display: grid;
  grid-template-columns: 1fr 220px;
  gap: 14px;
  margin-top: 16px;
}

/* ===== DISCOUNT ===== */
.discount-box {
  display: grid;
  gap: 8px;
}

.discount-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  border-radius: 10px;
  background: #f7f7f7;
  font-size: 13px;
  border: 1px solid #eee;
}

.discount-row.active {
  background: #fff5f2;
  border-color: #ee4d2d;
  color: #ee4d2d;
  font-weight: 600;
}

.discount-left {
  font-weight: 600;
}

.discount-right {
  color: #666;
  font-size: 12px;
}

/* ===== QUANTITY ===== */
.qty-box {
  border: 1px solid #eee;
  border-radius: 12px;
  padding: 12px;
  background: #fafafa;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.qty-label {
  font-size: 13px;
  margin-bottom: 8px;
  color: #555;
  font-weight: 600;
}

.qty-control {
  display: flex;
  border: 1px solid #ddd;
  border-radius: 10px;
  overflow: hidden;
}

.qty-control button {
  width: 38px;
  border: none;
  background: #f0f0f0;
  font-size: 18px;
  cursor: pointer;
}

.qty-control input {
  width: 60px;
  text-align: center;
  border: none;
  outline: none;
}

/* ===== MOBILE ===== */
@media (max-width: 640px) {
  .sale-qty-row {
    grid-template-columns: 1fr;
  }

  .qty-box {
    margin-top: 6px;
  }
}

/* ===== OVERLAY ===== */
.popup-dv-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, .55);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(4px);
}

/* ===== POPUP ===== */
.popup-dv {
  width: 95%;
  max-width: 920px;
  height: 80vh;
  background: #fff;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* ===== HEADER ===== */
.popup-dv-header {
  padding: 14px 18px;
  display: flex;
  justify-content: space-between;
  font-weight: 600;
  border-bottom: 1px solid #eee;
  background: #fafafa;
}

/* ===== TABS ===== */
.tab-bar {
  display: flex;
  border-bottom: 1px solid #eee;
}

.tab {
  flex: 1;
  text-align: center;
  padding: 12px;
  cursor: pointer;
  color: #666;
}

.tab.active {
  color: #ee4d2d;
  border-bottom: 3px solid #ee4d2d;
  font-weight: 600;
}

/* ===== CONTENT ===== */
.tab-content {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
}

/* ===== IMAGE ===== */
.main-img img {
  max-height: 400px;
  border-radius: 12px;
}

.thumb-list {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-top: 12px;
}

.thumb {
  width: 70px;
  height: 70px;
  border-radius: 10px;
  border: 2px solid transparent;
  cursor: pointer;
}

.thumb.active {
  border-color: #ee4d2d;
}

/* ===== SALE ===== */
.discount-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 12px;
  border-radius: 10px;
  background: #f9f9f9;
}

.discount-row.active {
  background: #fff5f2;
  color: #ee4d2d;
  font-weight: 600;
}

/* ===== QUANTITY ===== */
.qty-box {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}

.qty-control {
  display: flex;
  border: 1px solid #ddd;
  border-radius: 10px;
}

/* ===== PRICE ===== */
.price-summary {
  margin-top: 16px;
  padding: 14px;
  border-radius: 14px;
  border: 1px dashed #ee4d2d;
  background: #fff5f2;
}

.price-row {
  display: flex;
  justify-content: space-between;
}

.old {
  text-decoration: line-through;
  color: #999;
}

.final {
  color: #ee4d2d;
  font-weight: 700;
}

.save {
  margin-top: 6px;
  color: #ee4d2d;
  font-weight: 600;
}

/* ===== FOOTER ===== */
.popup-dv-footer {
  display: flex;
  gap: 12px;
  padding: 10px;
}

.action-btn {
  flex: 1;
  height: auto;
}

.btn-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-weight: 600;
}

/* 💻 Desktop: 1 dòng */
.action-text,
.action-price {
  white-space: nowrap;
}

/* 📱 Mobile: 2 dòng */
@media (max-width: 576px) {
  .btn-title {
    flex-direction: column;
    gap: 2px;
  }

  .action-text {
    font-size: 14px;
  }

  .action-price {
    font-size: 16px;
    font-weight: 700;
  }
}

.btn {
  flex: 1;
  border-radius: 12px;
  color: #fff;
  border: none;
  padding: 12px;
}

.btn.buy {
  background: linear-gradient(135deg, rgb(7, 149, 217), rgb(0, 120, 190));
}

.btn.rent {
  background: linear-gradient(135deg, #ee4d2d, #d81226);
}

.btn-title {
  font-size: 14px;
}

.btn-price {
  font-size: 18px;
  font-weight: 700;
}
</style>